import config from "../../../../config";
import * as modules from "./modules/";
const { vendor } = config;

const UnsubscribeNotificationTypePage = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default UnsubscribeNotificationTypePage;
